import Input from "component/ui/Input";
import React, { memo, useEffect, useState } from "react";
import HourSelect from "../common/hourSelect";
import RadioButton from "component/ui/RadioButton";
import {
  formatHourToTime,
  getTimeZone,
  revertTimeToHour,
} from "helper/appConstant";
import Button from "component/ui/Button";
import { AiFillPlusCircle } from "react-icons/ai";
import { FaCircleMinus } from "react-icons/fa6";
import { FiPlusCircle } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import SelectField from "component/ui/SelectField";
import { useDispatch, useSelector } from "react-redux";
import {
  addUpdateArena,
  getVenueSelectedSportsList,
  updateArena,
} from "store/slice/profile";
import { useNavigate } from "react-router-dom";

function AddUpdateArena({
  sportData,
  setShowArenaForm,
  setIsLoading,
  fetchBookingAvailabiltyList,
}) {
  let initialState = {
    spaceName: null,
    price: null,
    slotFrequency: null,
    rescheduleCancelFrequency: null,
    status: 4,
    openingTime: null,
    closingTime: null,
    // courtDetailsId: null,
    sameDayRescheduleFee: null,
    otherDayRescheduleFee: null,
    type: null,
    cancel_time: [{ time: "", value: null }],
  };
  const cancel_time_initialState = { time: "", value: null };
  const [formData, setFormData] = useState([initialState]);
  const dispatch = useDispatch();
  const { bookingAvailiabilityDetails } = useSelector((state) => state.profile);
  //   arena cancellation type
  const cancellation_type = [
    {
      id: "percent",
      label: " Percentage",
    },
    {
      id: "flat",
      label: "Flat Amount",
    },
  ];

  //frequencyHours
  const frequency_hours = [
    { id: 1, name: "1 Hours" },
    { id: 2, name: "2 Hours" },
    { id: 4, name: "4 Hours" },
    { id: 6, name: "6 Hours" },
    { id: 8, name: "8 Hours" },
    { id: 10, name: "10 Hours" },
    { id: 12, name: "12 Hours" },
    { id: 14, name: "14 Hours" },
    { id: 16, name: "16 Hours" },
    { id: 18, name: "18 Hours" },
    { id: 20, name: "20 Hours" },
    { id: 22, name: "22 Hours" },
    { id: 24, name: "24 Hours" },
  ];
  //   frequencyMinutesList
  const frequency_minutes = [
    {
      id: 30,
      name: "30 Minutes",
    },
    {
      id: 60,
      name: "60 Minutes",
    },
  ];
  //  hanlde oncange function
  const handleChange = (index, name, value) => {
    let temp = [...formData];
    temp[index][name] = value;
    setFormData(temp);
  };

  const validateForm = () => {
    for (let i = 0; i < formData.length; i++) {
      const arena = formData[i];
      const arenaNumber = i + 1;

      if (
        (!arena?.groundName || arena?.groundName.trim() === "") &&
        (!arena?.spaceName || arena?.spaceName.trim() === "")
      ) {
        toast.error(`Arena ${arenaNumber}: Please enter the arena name.`);
        return false;
      }

      if (!arena?.price || arena?.price <= 0) {
        toast.error(`Arena ${arenaNumber}: Please enter a valid price.`);
        return false;
      }

      if (!arena?.slotFrequency) {
        toast.error(`Arena ${arenaNumber}: Please select a slot frequency.`);
        return false;
      }

      if (!arena?.openingTime) {
        toast.error(`Arena ${arenaNumber}: Please select an opening time.`);
        return false;
      }

      if (!arena?.closingTime) {
        toast.error(`Arena ${arenaNumber}: Please select a closing time.`);
        return false;
      }

      if (!arena?.rescheduleCancelFrequency) {
        toast.error(
          `Arena ${arenaNumber}: Please select a reschedule/cancellation window.`
        );
        return false;
      }

      if (!arena?.sameDayRescheduleFee) {
        toast.error(
          `Arena ${arenaNumber}: Please enter the same-day reschedule fee.`
        );
        return false;
      }

      if (!arena?.otherDayRescheduleFee) {
        toast.error(
          `Arena ${arenaNumber}: Please enter the other-day reschedule fee.`
        );
        return false;
      }

      if (!arena?.type) {
        toast.error(
          `Arena ${arenaNumber}: Please select a cancellation slab type.`
        );
        return false;
      }

      // Validate each cancel_time object
      for (let j = 0; j < arena?.cancel_time?.length; j++) {
        const slab = arena?.cancel_time[j];
        const slabNumber = j + 1;

        if (!slab?.time || slab?.time.trim() === "") {
          toast.error(
            `Arena ${arenaNumber} → Slab ${slabNumber}: Please enter the time range.`
          );
          return false;
        }

        if (slab.value === null || slab.value === "" || isNaN(slab.value)) {
          toast.error(
            `Arena ${arenaNumber} → Slab ${slabNumber}: Please enter a valid value.`
          );
          return false;
        }
      }
    }

    return true;
  };

  const handleAddUpdateSuccess = (status) => {
    if (status) {
      setShowArenaForm(false);
      dispatch(getVenueSelectedSportsList());
      fetchBookingAvailabiltyList();
    }
    setIsLoading(false);
  };
  //  handle add update arena
  const handleSubmit = () => {
    if (!validateForm()) return;
    setIsLoading(true);
    const updatedArr = formData.map((obj) => ({
      ...obj,
      spaceName: obj?.spaceName ?? obj?.groundName,
      status: obj?.status ? obj?.status : 1,
      courtDetailsId: obj?._id,
    }));
    let request = {
      language: "en",
      sportsName: sportData?.name,
      numberOfSpaces: formData?.length,
      timeZone: getTimeZone(),
      sportsId: bookingAvailiabilityDetails?._id ?? null,
      sportsCourtsInfo: updatedArr,
    };
    if (bookingAvailiabilityDetails?._id) {
      dispatch(updateArena(request, handleAddUpdateSuccess));
    } else {
      dispatch(addUpdateArena(request, handleAddUpdateSuccess));
    }
  };
  console.log("formData", formData);
  //   set bookig details data
  useEffect(() => {
    if (bookingAvailiabilityDetails) {
      setFormData(
        JSON.parse(JSON.stringify(bookingAvailiabilityDetails?.courtDetails))
      );
    } else {
      setFormData([initialState]);
    }
  }, [bookingAvailiabilityDetails]);
  return (
    <div className="bg-white min-h-screen rounded-md mt-2 md:p-5 p-3">
      <div className="flex gap-4 items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            style={{ background: `#${sportData?.color}` }}
            className="h-8 w-8 md:h-10 md:w-10 bg-gray-300 text-xl rounded-full font-semibold flex items-center justify-center bg-center bg-cover"
          >
            {bookingAvailiabilityDetails
              ? bookingAvailiabilityDetails?.icon
              : sportData?.icon}
          </div>

          <div className="pt-1">
            {bookingAvailiabilityDetails
              ? bookingAvailiabilityDetails?.sportsName
              : sportData?.name}
          </div>
        </div>

        <div className="group">
          <div className="flex items-center gap-3 px-3 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-sm border border-blue-100 hover:shadow-md transition-all duration-200">
            <div className="flex items-center justify-center w-8 h-8 bg-white rounded-lg shadow-sm">
              <svg
                className="w-4 h-4 text-indigo-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                />
              </svg>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-gray-900">
                {formData?.length ?? 0}
              </span>
              <span className="text-xs text-gray-500 font-medium">Arenas</span>
            </div>
          </div>
        </div>
      </div>

      {/* border */}
      <div className="border border-gray-200 my-3"></div>

      {/* form */}
      {formData?.map((item, index) => {
        return (
          <>
            <div className="mt-4" key={index}>
              <div className="flex justify-between my-4">
                <span className="text-lg">Arena {index + 1}</span>
                {formData?.length != 1 && (
                  <MdDelete
                    color="red"
                    size={20}
                    className="cursor-pointer"
                    onClick={() => {
                      setFormData((prev) => prev.filter((_, i) => i !== index));
                    }}
                  />
                )}
              </div>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-4 ">
                <Input
                  value={item?.spaceName ?? item?.groundName}
                  onChange={(e) => handleChange(index, "spaceName", e)}
                  label="Arena Name"
                  isRequired
                  name="spaceName"
                  placeholder="Enter name"
                />
                <Input
                  value={item?.price || null}
                  onChange={(e) => handleChange(index, "price", e * 1)}
                  label="Arena Price"
                  placeholder="Enter Price"
                  isRequired
                  type="number"
                  name="price"
                />
                <SelectField
                  id="gender-select"
                  placeholder="Select arena frequency"
                  label="Arena Frequency(In Minutes)"
                  isRequired={true}
                  name="slotFrequency"
                  options={frequency_minutes}
                  onChange={(e) => handleChange(index, "slotFrequency", e * 1)}
                  value={item?.slotFrequency || null}
                />

                <div>
                  <label className="text-sm ">
                    Arena Slot Time
                    <span className="text-red-500 ml-1 font-bold">*</span>
                  </label>
                  <div className="flex gap-3">
                    <HourSelect
                      boxTopMargin="0"
                      height="h-12"
                      isShowFullValue
                      name="openingTime"
                      hideArrow={true} // hides the native down arrow
                      value={
                        item?.openingTime
                          ? revertTimeToHour(item?.openingTime)
                          : ""
                      }
                      onChange={(e) =>
                        handleChange(
                          index,
                          "openingTime",
                          formatHourToTime(e.target.value)
                        )
                      }
                    />
                    <HourSelect
                      boxTopMargin="0"
                      height="h-12"
                      name="closingTime"
                      isShowFullValue
                      value={
                        item?.closingTime
                          ? revertTimeToHour(item?.closingTime)
                          : ""
                      }
                      onChange={(e) =>
                        handleChange(
                          index,
                          "closingTime",
                          formatHourToTime(e.target.value)
                        )
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="grid md:grid-cols-3 grid-cols-1 gap-4 mt-4">
                <SelectField
                  id="gender-select"
                  placeholder="Select arena reschedule/cancellation window"
                  label="Arena Reschedule/Cancellation Window"
                  isRequired={true}
                  name="rescheduleCancelFrequency"
                  options={frequency_hours}
                  onChange={(e) =>
                    handleChange(index, "rescheduleCancelFrequency", e * 1)
                  }
                  value={item?.rescheduleCancelFrequency}
                />
                <Input
                  label="Same Day Reschedule Fee"
                  isRequired
                  placeholder="Enter same day reschedule fee"
                  type="number"
                  value={item?.sameDayRescheduleFee || null}
                  onChange={(e) =>
                    handleChange(index, "sameDayRescheduleFee", e * 1)
                  }
                  name="sameDayRescheduleFee"
                />
                <Input
                  label="Other Day Reschedule Fee"
                  isRequired
                  placeholder="Enter other day reschedule fee"
                  type="number"
                  value={item?.otherDayRescheduleFee || null}
                  onChange={(e) =>
                    handleChange(index, "otherDayRescheduleFee", e * 1)
                  }
                  name="otherDayRescheduleFee"
                />
              </div>
              <div className="grid md:grid-cols-2 grid-cols-1 gap-4 p-2 mt-3  ">
                <div>
                  <RadioButton
                    label="Arena Cancellation Slab Type"
                    isRequired={true}
                    inputClassName="pt-1 text-sm"
                    options={cancellation_type}
                    selected={item?.type}
                    onChange={(e) =>
                      handleChange(index, "type", e.target.value)
                    }
                  />
                  <div className="mt-3">
                    <label className="text-base font-medium text-gray-700 mb-2">
                      Cancellation Time Slab
                      <span className="text-red-500 ml-1 font-bold">*</span>
                    </label>
                    {item?.cancel_time?.map((cancel, cancelIndex) => {
                      return (
                        <div
                          className="grid grid-cols-6 gap-3 mt-3"
                          key={cancelIndex}
                        >
                          <Input
                            disabled
                            label="From"
                            inputClassName="w-full"
                            value={
                              cancelIndex == 0 ? 0 : cancel?.time?.split("-")[0]
                            }
                          />

                          <div className="col-span-2">
                            <HourSelect
                              label={" To"}
                              placeholder="End time slot"
                              isRequired
                              boxTopMargin="0"
                              height="h-12"
                              isNotIcon
                              value={cancel?.time?.split("-")[1]}
                              onChange={(e) => {
                                let obj = [...formData];
                                let temp = [...obj[index].cancel_time];
                                temp[cancelIndex].time = `${
                                  cancelIndex == 0
                                    ? 0
                                    : temp[cancelIndex]?.time?.split("-")[0]
                                }-${e.target.value}`;
                                obj[index]["cancel_time"] = temp;
                                setFormData(obj);
                              }}
                            />
                          </div>
                          <div className="col-span-2">
                            <Input
                              label={
                                item?.type == "flat" ? "Amount" : "Percentage"
                              }
                              placeholder={
                                item?.type == "flat" ? "Amount" : "Percentage"
                              }
                              isRequired
                              type="number"
                              value={cancel?.value || ""}
                              onChange={(e) => {
                                let value = Number(e);
                                // if type is NOT flat, max allowed is 100
                                if (item?.type !== "flat" && value > 100) {
                                  value = 100;
                                }
                                let obj = [...formData];
                                let temp = [...obj[index].cancel_time];
                                temp[cancelIndex].value = value;
                                obj[index].cancel_time = temp;

                                setFormData(obj);
                              }}
                              name="sameDayRescheduleFee"
                            />
                          </div>
                          {cancelIndex !== 0 && (
                            <div className="flex items-center justify-center pt-6">
                              <FaCircleMinus
                                size={20}
                                color="red"
                                className="cursor-pointer"
                                onClick={() => {
                                  let obj = [...formData];
                                  let temp = [...obj[index].cancel_time];
                                  temp = temp.filter(
                                    (item, filterIndex) =>
                                      filterIndex != cancelIndex
                                  );
                                  obj[index]["cancel_time"] = temp;
                                  setFormData(obj);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                    <div
                      className="cursor-pointer flex gap-2 text-md pt-3"
                      onClick={() => {
                        let temp = [...formData];

                        if (
                          !item?.cancel_time[
                            item?.cancel_time?.length - 1
                          ]?.time?.split("-")[1] ||
                          item?.cancel_time[
                            item?.cancel_time?.length - 1
                          ]?.time?.split("-")[1] == 0
                        ) {
                          toast.error(
                            "Please enter To time in cancellation time slab"
                          );
                          return;
                        }
                        if (
                          !item?.cancel_time[item?.cancel_time?.length - 1]
                            ?.value
                        ) {
                          toast.error(
                            "Please enter percentage/amount  in cancellation time slab"
                          );
                          return;
                        }
                        temp[index].cancel_time.push({
                          time: `${
                            item?.cancel_time[
                              item?.cancel_time?.length - 1
                            ]?.time?.split("-")[1]
                          }-0`,
                          value: null,
                        });
                        setFormData(temp);
                      }}
                    >
                      <AiFillPlusCircle size={20} color="#2bace2" /> Add
                      Cancellation Time Slab
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {index == formData?.length - 1 && (
              <div className="flex justify-center mt-2">
                <Button children={"Submit"} size="sm" onClick={handleSubmit} />
              </div>
            )}
            <div class="border-b-4 border-gray-200 my-3"></div>
          </>
        );
      })}

      <div className="flex justify-end">
        <Button
          icon={<FiPlusCircle size={20} color="white" />}
          children={"Add Space"}
          onClick={() => {
            setFormData((prev) => [...prev, { ...initialState }]);
          }}
        />
      </div>
    </div>
  );
}

export default memo(AddUpdateArena);
